export default {"src":"/_next/static/media/white-logo.813d1ba9.svg","height":40,"width":193,"blurWidth":0,"blurHeight":0};